import styled from 'styled-components'

import { DeprecatedText, TypeStyle, timingSlower } from '@syconium/little-miss-figgy'

import { fadeIn } from '../../../../../../brunswick/styles/shared'

export const Bar = styled.div`
  background-color: white;
  border-bottom: 1px solid ${o => o.theme.color.deprecated.stone};
  left: 0;
  padding: 20px 15px;
  position: sticky;
  right: 0;
  top: 0;
  z-index: ${o => o.theme.zIndex.foregroundContent};
`

export const TopActions = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Headline = styled(DeprecatedText)`
  line-height: 22px;
`

export const ClearAllButton = styled.button`
  ${TypeStyle.css.bodySmall};
  animation: ${fadeIn} ${timingSlower} ease 0s 1 both;
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 22px;
  margin-right: 64px;
  text-transform: uppercase;
`

export const SelectedCategoryFiltersList = styled(DeprecatedText)`
  line-height: 1.5em;
  margin-top: 4px;
`
